import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import config from '../../../config';

import { getAvailableTypes } from '../ConversationActions';
import { recordMessengerIntentRequest } from '../../User/UserActions';
import withRouter from '../../../components/Router/WithRouter';
import { readClientPlatform, suggestIntentDevice } from './import/detectTutorialPlatform';

function ConversationTypeSelector({ navigate, dispatch, title = null, hint = null, className = undefined }) {
    const handleClick = type => {
        dispatch(recordMessengerIntentRequest(type, suggestIntentDevice(type, readClientPlatform())));
        navigate(`/conversation/${type}`);
        window.dataLayer?.push({ event: 'select_content', content_type: 'conversation', content_id: type });
    };

    const renderSelector = (type, onClick = null) => (
        <button type="button" key={type} onClick={onClick || (() => handleClick(type))} className="conversations-lux-provider">
            <span className="conversations-lux-provider__icon"><img src={`${config.staticUrl}assets/images/${type}.png`} alt={type} /></span>
            <span className="conversations-lux-provider__label">{type.toUpperCase()}</span>
        </button>
        );

    return (
        <div className={classNames('atelier-card conversations-lux-empty', className)}>
            {title && <h3 className="conversations-lux-empty__title atelier-title">{title}</h3>}
            {hint && <p className="conversations-lux-empty__hint atelier-hint">{hint}</p>}
            <div className="conversations-lux-empty__providers">
				{getAvailableTypes().map(type => renderSelector(type))}
            </div>
        </div>
    );
}

ConversationTypeSelector.propTypes = {
    navigate: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    title: PropTypes.node,
    hint: PropTypes.node,
    className: PropTypes.string,
};

export default withRouter(connect()(ConversationTypeSelector));
